import Typography from '@mui/material/Typography';
import {
    OlDecimal,
    OlUpperAlpha,
    LiNormal,
    LiBold
} from '../components/customComponent/list';
import { LinkExternalSystem } from '../components/customComponent/link';


const Pravacy = () => {

    return (
        <>
            <Typography variant="h2">隱私權保護政策</Typography>
            <Typography>非常歡迎您光臨 www.haitech.com.tw/ (以下簡稱本網站)，為了讓您能夠安心的使用本網站的各項服務與資訊，特此向您說明本網站的隱私權保護政策，以保障您的權益，請您詳閱下列內容：</Typography>

            <Typography variant="h3" mt={4}>隱私權保護政策的適用範圍</Typography>
            <Typography>隱私權保護政策內容，包括本網站如何處理在您使用網站服務時收集到的個人識別資料。隱私權保護政策不適用於本網站以外的相關連結網站，也不適用於非本網站所委託或參與管理的人員。</Typography>

            <Typography variant="h3" mt={4}>個人資料的蒐集、處理及利用方式</Typography>

            <Typography variant="h4">資料使用之目的及類別</Typography>
            <OlDecimal>
                <LiBold>資料使用之目的</LiBold>
                <Typography>(依據法務部公告之「個人資料保護法之特定目的及個人資料之類別」填載如下)<br/>
                    040 行銷、063 非公務機關依法定義務所進行個人資料之蒐集處理及利用、075 科技行政、090 消費者、客戶管理與服務、099 國內外交流業務、107 採購與供應管理、135 資 (通)訊服務。</Typography>

                <LiBold>資料使用之類別</LiBold>
                <Typography>(依據法務部公告之「個人資料保護法之特定目的及個人資料之類別」填載如下)<br/>
                    C001辨識個人者：包括但不限於姓名、住家電話、行動電話、電子郵件地址、提供網路身分認證或申辦查詢服務之紀錄、網際網路協定位址、Cookie 及其他任何可辨識資料本人者。<br/>
                    C038 職業</Typography>
            </OlDecimal>

            <Typography variant="h4">資料使用之期間、地區、對象及方式</Typography>
            <OlDecimal>
                <LiBold>資料使用之期間</LiBold>
                <Typography>上述個人資料之利用期間係指依照蒐集之特定目的、相關法令所定、因執行業務所須之必要保存期間 (較法規規定期間長者)或依個別契約所定之保存年限為利用存續期間。</Typography>

                <LiBold>資料使用之地區</LiBold>
                <Typography>用於本公司位於全球各地之營業所，以便提供相關服務。</Typography>

                <LiBold>資料使用之對象及方式</LiBold>
                <OlUpperAlpha>
                    <LiNormal>介紹與行銷產品及廣告，如本公司及與本公司有特約合作關係之第三人及本公司之集團與合作夥伴所提供產品和服務。</LiNormal>
                    <LiNormal>將收集的問卷調查內容進行統計與分析，分析結果之統計數據或說明文字呈現，除供內部研究外，我們會視需要公佈統計數據及說明文字，但不涉及特定個人之資料。</LiNormal>
                </OlUpperAlpha>
            </OlDecimal>

            <Typography variant="h3" mt={4}>資料之保護</Typography>
            <Typography>本網站主機均設有防火牆、防毒系統等相關的各項資訊安全設備及必要的安全防護措施，加以保護網站及您的個人資料採用嚴格的保護措施，只由經過授權的人員才能接觸您的個人資料，如有違反保密義務者，將會受到相關的法律處分。<br/>
                        如因業務需要有必要委託其他單位提供服務時，本網站亦會嚴格要求其遵守保密義務，並且採取必要檢查程序以確定其將確實遵守。</Typography>

            <Typography variant="h3" mt={4}>網站對外的相關連結</Typography>
            <Typography>本網站的網頁提供其他網站的網路連結，您也可經由本網站所提供的連結，點選進入其他網站。但該連結網站不適用本網站的隱私權保護政策，您必須參考該連結網站中的隱私權保護政策。</Typography>

            <Typography variant="h3" mt={4}>與第三人共用個人資料之政策</Typography>
                <Typography>本網站絕不會將您的個人資料揭露於與本服務無關之第三人或上述目的以外之用途。但不包括下列情形：</Typography>
                <OlDecimal>
                    <LiNormal>經由您書面同意</LiNormal>
                    <LiNormal>法律明文規定</LiNormal>
                    <LiNormal>為免除您生命、身體、自由或財產上之危險</LiNormal>
                    <LiNormal>與公務機關或學術研究機構合作，基於公共利益為統計或學術研究而有必要，且資料經過提供者處理或蒐集者依其揭露方式無從識別特定之當事人。</LiNormal>
                    <LiNormal>當您在網站的行為，違反服務條款或可能損害或妨礙網站與其他使用者權益或導致任何人遭受損害時，經網站管理單位研析揭露您的個人資料是為了辨識、聯絡或採取法律行動所必要者。</LiNormal>
                    <LiNormal>本網站委託廠商協助蒐集、處理或利用您的個人資料時，將對委外廠商或個人善盡監督管理之責。</LiNormal>
                </OlDecimal>

            <Typography variant="h3" mt={4}>您對於其個人資料所享有之權利</Typography>
            <Typography>您有權隨時提出以下需求：</Typography>
            <OlDecimal>
                <LiNormal>個人資料查詢、取得複製本 (得酌收必要成本和費用)，及更正或補充。</LiNormal>
                <LiNormal>停止將您的個人資料用於行銷或接收特定或各類行銷資料。</LiNormal>
                <LiNormal>除法令要求保留之用戶個人資料外，期間屆滿時要求刪除、停止處理及利用您的個人資料。</LiNormal>
            </OlDecimal>

            <Typography variant="h3" mt={4}>Cookie之使用</Typography>
            <Typography>為了提供您最佳的服務，本網站會在您的電腦中放置並取用我們的 Cookie，若您不願接受 Cookie 的寫入，您可在您使用的瀏覽器功能項中設定隱私權等級為高，即可拒絕 Cookie 的寫入，但可能會導致網站某些功能無法正常執行 。於一般瀏覽時，伺服器會自行記錄相關行徑，包括您使用連線設備的 IP 位址、使用時間、使用的瀏覽器、瀏覽及點選資料記錄等，做為我們增進網站服務的參考依據，此記錄為內部應用，決不對外公佈。</Typography>

            <Typography variant="h3" mt={4}>隱私權保護政策之修正</Typography>
            <Typography>本網站隱私權保護政策將因應需求隨時進行修正，修正後的條款將公告於網站上，並於公告時起立即生效。</Typography>

            <Typography variant="h3" mt={4}>居住在歐洲經濟區 (EEA) 或瑞士的使用者</Typography>
            <Typography>我們從您獲得或所獲得關於您的個人資料有可能會按照本隱私政策所述，在歐洲經濟區或瑞士以外傳送、處理及儲存。我們十分重視您的隱私，因此會採取措施保護您的資料，且已與我們的第三方服務提供商和合作夥伴實施類似適當保障，包括根據歐盟一般資料保護規範確保完善的資料保護水平。</Typography>

            <Typography variant="h3" mt={4}>若您對於本網站之個資及隱私權政策有任何建議或您要求移除您於本網站曾登錄過之個人資訊，請 email： <LinkExternalSystem href="mailto:tda@tradeserv.com">tda@tradeserv.com</LinkExternalSystem>，我們將會立刻處理並回覆您處理之結果。</Typography>
        </>
    )
}

export default Pravacy;